function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useContext } from 'react';
import WhySvg from "./svg/why-svg";
import { useWorkFlow } from "./contexts/workflow";
import { _translate as t, WeverCoreContext } from "../services/core";
var QuestionWhy = function QuestionWhy() {
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDeployed = _useState2[0],
    setDeployed = _useState2[1];
  var index = locale.indexOf('-');
  var localeFormated = locale;
  if (index) {
    localeFormated = locale.substr(0, index);
  }
  if (!collector.currentQuestion || !collector.currentQuestion.why || !collector.currentQuestion.why[localeFormated]) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "collectorQuestionWhy ".concat(collector.loaderQuestion ? 'invisible' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header d-flex justify-content-center align-items-end ".concat(isDeployed ? 'deployed text-dark' : ''),
    onClick: function onClick() {
      return setDeployed(!isDeployed);
    }
  }, /*#__PURE__*/React.createElement(WhySvg, {
    fill: isDeployed ? 'black' : null
  }), /*#__PURE__*/React.createElement("span", null, t('why_question'))), /*#__PURE__*/React.createElement("div", {
    className: "body",
    style: {
      display: isDeployed ? 'block' : 'none'
    }
  }, /*#__PURE__*/React.createElement("span", null))));
};
export default QuestionWhy;